import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import logo from '../assets/logo.svg';

const STORAGE_KEY = 'wesamsam-scanandfindit-promo-dismissed';
const WEBSITE_URL = 'https://scanandfindit.com/';

export default function ScanAndFindItPromo() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY) === 'true') {
      return;
    }
    const timer = window.setTimeout(() => setVisible(true), 1200);
    return () => window.clearTimeout(timer);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <aside
      className="scan-promo"
      role="dialog"
      aria-label="ScanAndFindIt promotion"
      aria-describedby="scan-promo-heading"
    >
      <button
        type="button"
        className="scan-promo-close"
        onClick={dismiss}
        aria-label="Dismiss"
      >
        ×
      </button>
      <img
        src={logo}
        alt="Wesam Technologies logo"
        className="scan-promo-icon"
        width={56}
        height={56}
      />
      <p className="scan-promo-title" id="scan-promo-heading">
        Try ScanAndFindIt
      </p>
      <p className="scan-promo-text">
        Scan barcodes, check ingredients, and spot risks with AI.
      </p>
      <Button
        href={WEBSITE_URL}
        variant="outline-warning"
        className="scan-promo-cta"
        target="_blank"
        rel="noopener noreferrer"
      >
        scanandfindit.com
      </Button>
      <button type="button" className="scan-promo-later" onClick={dismiss}>
        Maybe later
      </button>
    </aside>
  );
}
